import { Col, DatePicker, Pagination, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { Button, Charts, Loader, Modal, Picker, Switch, Table, Text, TextField } from '../../components';
import moment from 'moment';
import { ApiCaller, Colors, Fonts, Utils } from '../../config';

const getMostUsedServices = async (mostUsedServices) => {
    try {
        let res = await ApiCaller.Get(`/admin/dashboard/most-used-services?offset=${mostUsedServices.offset}&limit=${mostUsedServices.limit}&startDate=${mostUsedServices.startDate ?? ''}&endDate=${mostUsedServices.endDate ?? ''}`);
        return res?.data?.data
    } catch (error) {
        return error
    }
}

const ServiceCommission = () => {
    // commission modal
    const [showCommissionModal, setShowCommissionModal] = useState(false);
    const [messageDetails, setMessageDetails] = useState({
        id: null,
        isEnabled: false,
        percentage: 0
    })
    const [mostUsedServicesFilters, setMostUsedServicesFilters] = useState({
        offset: 0,
        page: 1,
        limit: 10,
        total: 0,
        startDate: null,
        endDate: null,
        isRefresh: false,
    })
    const [mostUsedServices, setMostUsedServices] = useState([]);
    const [mostUsedServicesLoading, setMostUsedServicesLoading] = useState(false);

    // most used services
    useEffect(() => {
        (
            async () => {
                try {
                    setMostUsedServicesLoading(true)
                    let mostUsedServices = await getMostUsedServices(mostUsedServicesFilters);
                    setMostUsedServicesFilters({ ...mostUsedServicesFilters, total: mostUsedServices?.count })
                    setMostUsedServices(mostUsedServices?.data)
                }
                catch (error) {
                    console.log(error)
                }
                finally {
                    setMostUsedServicesLoading(false)
                }
            }
        )()
    }, [mostUsedServicesFilters.isRefresh])


    // commission toggle change handler
    // case 1: if toggle value is true then a modal going to open - user enter commission - submit
    // case 2: else if value is false then just make the percentage 0 for that service.
    const handleChangeStatus = async (id, value) => {
        let payload = {
            id,
            isEnabled: value,
            percentage: 0
        }
        setMessageDetails(payload)
        // if true then we have to show a modal to enter commission.
        if (value) {
            setShowCommissionModal(value)
        }
        // or else we just have to make a commission percentage 0 for that service.
        else {
            let res = await submitCommission(payload);
            if (res) {
                setMostUsedServicesFilters({ ...mostUsedServicesFilters, isRefresh: !mostUsedServicesFilters.isRefresh });
                setMessageDetails({
                    id: null,
                    isEnabled: false,
                    percentage: 0
                })
                Utils.showSnackBar({ message: res?.message });
            }
        }
    }

    // commission submit handler
    const commissionSubmitHandler = async () => {
        if (messageDetails?.percentage == 0) return
        else if (messageDetails?.percentage > 100) {
            Utils.showSnackBar({ message: "Percentage should not be greater than 100", severity: "error" });
            return
        }
        let res = await submitCommission(messageDetails);
        if (res) {
            setMostUsedServicesFilters({ ...mostUsedServicesFilters, isRefresh: !mostUsedServicesFilters.isRefresh });
            setShowCommissionModal(false)
            setMessageDetails({
                id: null,
                isEnabled: false,
                percentage: 0
            })
            Utils.showSnackBar({ message: res?.message });
        }
    }

    // date handler
    const dateHandler = (date, dateStrings) => {
        setMostUsedServicesFilters({ ...mostUsedServicesFilters, offset: 0, page: 1, startDate: dateStrings[0], endDate: dateStrings[1], isRefresh: !mostUsedServicesFilters.isRefresh })
    }

    // pagination handler for most used services table
    const handlePaginationChange = (pageNumber) => {
        let offset = (pageNumber - 1) * mostUsedServicesFilters.limit;
        setMostUsedServicesFilters({ ...mostUsedServicesFilters, offset: offset, page: pageNumber, isRefresh: !mostUsedServicesFilters.isRefresh });
    };

    const submitCommission = async (data) => {
        try {
            const { id, ...rest } = data;
            let res = await ApiCaller.Put(`/admin/dashboard/service/${id}`, { ...rest });
            if (res?.status == 200 || res?.data?.status == 200) {
                return res?.data?.data ?? res?.data ?? { message: "Commission updated successfully" };
            }
            else {
                Utils.showSnackBar({ message: res?.data?.error?.message, severity: "error" });
            }
        } catch (error) {
            Utils.showSnackBar({ message: error?.data?.error?.message, severity: "error" });
        }
    }

    return (
        < Row
            className="row-div mb-10 mt-20" style={{ justifyContent: 'space-between' }} justify='space-between'>
            <Col span={12} style={{ marginBottom: '15px' }}>
                <Text.Heading
                    fontSize={19}
                    fontFamily={Fonts["Poppins-SemiBold"]}
                    color={Colors.Black}
                    fontWeight={600}
                    text={"Most Used Services And Commission Management"}
                    textAlign={'left'}
                />
            </Col>
            <Col span={8} className='filters-item'>
                <DatePicker.RangePicker className='range-picker-status' onChange={dateHandler} />
            </Col>
            <Col span={24}>
                {
                    mostUsedServicesLoading ?
                        <Col className='loader table-loader-container'>
                            <Loader.Circular />
                        </Col>
                        :
                        <>
                            <Table.AntDesignTable
                                className="user-table"
                                columns={[
                                    {
                                        title: "Service Name",
                                        dataIndex: "name",
                                        key: "name",
                                        render: (text) => (
                                            <span>
                                                {text?.length > 20
                                                    ? `${text?.slice(0, 20)}...`
                                                    : text}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Total Bookings",
                                        dataIndex: "totalBookings",
                                        key: "totalBookings",
                                        render: (text) => (
                                            <span>
                                                {text ?? 0}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Revenue Generated",
                                        dataIndex: "revenueGenerated",
                                        key: "revenueGenerated",
                                        render: (text) => (
                                            <span>
                                                {text != null ? Number(text).toFixed(2) : "0.00"}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Avg Commission",
                                        dataIndex: "avgCommission",
                                        key: "avgCommission",
                                        render: (text) => (
                                            <span>
                                                {text != null ? Number(text).toFixed(2) : "0.00"}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Percentage",
                                        dataIndex: "percentage",
                                        key: "percentage",
                                        render: (text) => (
                                            <span>
                                                {text != null ? Number(text).toFixed(2) : "0.00"}%
                                            </span>
                                        ),
                                    },
                                    {
                                        title: "Action",
                                        dataIndex: "",
                                        render: (text, record) =>
                                            record?.status !== 3 && (
                                                <Switch.Basic
                                                    checked={!!record?.isEnabled}
                                                    onChange={(value) =>
                                                        handleChangeStatus(
                                                            record?.id,
                                                            value
                                                        )
                                                    }
                                                />
                                            ),
                                    },
                                ]}
                                data={mostUsedServices}
                                pagination={true}
                                rowKey="key"
                                loading={false}
                            />
                            <Row justify="center" className="mt-20">
                                <Col>
                                    <Pagination
                                        responsive="true"
                                        showLessItems="true"
                                        pageSize={mostUsedServicesFilters.limit}
                                        current={mostUsedServicesFilters.page}
                                        total={mostUsedServicesFilters.total}
                                        onChange={handlePaginationChange}
                                    />
                                </Col>
                            </Row>
                        </>
                }
            </Col>

            {/* commission amount modal */}
            {showCommissionModal && (
                <Modal.AntDesignModal
                    className=""
                    centered={true}
                    title=""
                    isModalVisible={showCommissionModal}
                    handleCancel={() => {
                        setShowCommissionModal(false);
                        setMessageDetails({
                            id: null,
                            isEnabled: false,
                            percentage: 0
                        });
                    }}
                >
                    <Row className="" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
                        <Col>
                            <Text.Heading
                                fontSize={24}
                                fontFamily={Fonts["Poppins-SemiBold"]}
                                color={Colors.Black}
                                fontWeight={600}
                                text={"Set Commission"}
                            />
                        </Col>

                        <Col span={24} style={{ marginTop: '10px' }}>
                            <TextField.CustomInput
                                value={messageDetails?.percentage}
                                placeholder={"Commission ..."}
                                style={{ border: '1px solid', width: '150px', padding: '6px', borderRadius: '6px' }}
                                onChange={(e) => setMessageDetails({ ...messageDetails, percentage: Number(e.target.value) })}
                            />
                        </Col>
                        <Row className="mt-20 flex-end">
                            <Col>
                                <Button.Basic
                                    onClick={commissionSubmitHandler}
                                    text={"Send"}
                                    className="message-btn w-500 mr-10"
                                />
                            </Col>
                        </Row>
                    </Row>
                </Modal.AntDesignModal>
            )}
        </Row>
    )
}

export default ServiceCommission